// optional large view ("Liquid"-like): whole app zoomed, layouts single column
const KEY = 'giss_ui_scale';
export const SCALES = [1, 1.2, 1.4];
const CLS = ['', 'ui-l', 'ui-xl'];

export const getScale = () => { const v = +localStorage.getItem(KEY); return SCALES[v] ? v : 0; };

// phone shown in Chrome "desktop site" mode (wide 980px layout): zoom back to the real phone width
export const desktopFix = () => {
  const touch = window.matchMedia?.('(pointer: coarse)').matches, sw = window.screen.width;
  return touch && sw > 0 && sw < 900 && window.innerWidth >= 800 && window.innerWidth > sw * 1.2 ? window.innerWidth / sw : 1;
};
let fix = 1;
export const uiZoom = () => SCALES[getScale()] * fix;

// in desktop-site mode CSS sees ~980px: re-apply the phone (max-width) media rules for the real width
function phoneMedia(on, w) {
  let el = document.getElementById('giss-dfix-mq');
  if (!on) { el?.remove(); return; }
  const out = [];
  for (const sh of document.styleSheets) {
    let rules;
    try { rules = sh.cssRules; } catch { continue; }
    for (const r of rules || []) {
      const m = r.media && /^\(max-width:\s*(\d+)px\)$/.exec(r.conditionText || r.media.mediaText);
      if (m && w <= +m[1]) out.push(...[...r.cssRules].map((x) => x.cssText));
    }
  }
  if (!el) { el = document.createElement('style'); el.id = 'giss-dfix-mq'; document.head.appendChild(el); }
  el.textContent = out.join('\n');
}

// body zoom does not scale vw/vh: re-emit every rule using them, divided by --z
const UNIT = /(-?\d*\.?\d+)(dvh|svh|lvh|vw|vh)\b/g;
function zoomUnits(on) {
  let el = document.getElementById('giss-zoom-units');
  if (!on) { el?.remove(); return; }
  if (el?.dataset.done) return;
  const out = [];
  const walk = (rules) => {
    for (const r of rules || []) {
      if (r.media) { if (window.matchMedia(r.media.mediaText).matches) walk(r.cssRules); continue; }
      if (!r.style || !r.selectorText || /ui-big|ui-l\b|ui-xl/.test(r.selectorText)) continue;
      const props = [];
      for (const k of r.style) {
        const v = r.style.getPropertyValue(k);
        if (UNIT.test(v) && !v.includes('--z')) props.push(`${k}: ${v.replace(UNIT, 'calc($1$2 / var(--z))')}${r.style.getPropertyPriority(k) ? ' !important' : ''}`);
        UNIT.lastIndex = 0;
      }
      if (props.length) out.push(`${r.selectorText.split(',').map((x) => `html.ui-big ${x.trim().replace(/^html(\.[\w-]+)*\s*/, '')}`).join(', ')} { ${props.join('; ')} }`);
    }
  };
  for (const sh of document.styleSheets) { if (sh.ownerNode?.id === 'giss-zoom-units') continue; try { walk(sh.cssRules); } catch { /* cross-origin */ } }
  if (!el) { el = document.createElement('style'); el.id = 'giss-zoom-units'; document.head.prepend(el); }
  el.textContent = out.join('\n');
  el.dataset.done = '1';
}

// big view on a wide desktop keeps the desktop layout (office split, one-row header)
const narrow = () => document.documentElement.classList.toggle('ui-narrow', window.innerWidth / uiZoom() < 1024);
window.addEventListener('resize', narrow);

// size switch keeps the measured fix; only start / re-check measure again
let measured = false;
export function applyScale(i = getScale(), refix = false) {
  const h = document.documentElement;
  if (refix || !measured) { fix = desktopFix(); measured = true; }
  const z = SCALES[i] * fix;
  h.classList.remove('ui-l', 'ui-xl', 'ui-big', 'ui-dfix');
  if (i) h.classList.add(CLS[i]);
  if (z > 1) h.classList.add('ui-big');
  if (fix > 1) h.classList.add('ui-dfix');
  narrow();
  h.style.setProperty('--z', z);
  if (document.body) document.body.style.zoom = z > 1 ? String(z) : '';
  phoneMedia(fix > 1, window.innerWidth / z);
  zoomUnits(z > 1);
  localStorage.setItem(KEY, String(i));
  setTimeout(() => window.dispatchEvent(new Event('resize')), 60);
}

applyScale();
if (!document.body) document.addEventListener('DOMContentLoaded', () => applyScale(getScale(), true));
window.addEventListener('load', () => { if (fix > 1) phoneMedia(true, window.innerWidth / uiZoom()); if (uiZoom() > 1) { document.getElementById('giss-zoom-units')?.remove(); zoomUnits(true); } });
export const effWidth = () => window.innerWidth / uiZoom();
// viewport can be wide only for a moment (app start, fullscreen, rotate): re-check and undo a wrong zoom
let tm;
const recheck = () => {
  clearTimeout(tm);
  tm = setTimeout(() => {
    const f = desktopFix();
    if (Math.abs(f - fix) <= 0.05) return;
    if (f === 1) { applyScale(getScale(), true); return; }
    // zooming in only if the wide viewport is still there a moment later (no flash while switching size)
    tm = setTimeout(() => { if (Math.abs(desktopFix() - fix) > 0.05) applyScale(getScale(), true); }, 700);
  }, 250);
};
['resize', 'orientationchange', 'pageshow'].forEach((e) => window.addEventListener(e, recheck));
document.addEventListener('fullscreenchange', recheck);
document.addEventListener('visibilitychange', recheck);
